import { render, staticRenderFns } from "./lp-session-card.vue?vue&type=template&id=070a0956&"
import script from "./lp-session-card.vue?vue&type=script&lang=js&"
export * from "./lp-session-card.vue?vue&type=script&lang=js&"
import style0 from "./lp-session-card.vue?vue&type=style&index=0&id=070a0956&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports